import PropTypes from "prop-types";

import MediaPicker from "components/content/MediaPicker";

/**
 * Batch 2.1 — <FeaturedImagePicker>. A thin MediaPicker preset for the public
 * featured image: image MIME filter, public visibility.
 */
function FeaturedImagePicker({ value, onChange, websiteId, label }) {
  return (
    <MediaPicker
      value={value}
      onChange={onChange}
      websiteId={websiteId}
      visibility="public"
      accept="image/*"
      label={label}
    />
  );
}

FeaturedImagePicker.defaultProps = {
  value: null,
  websiteId: undefined,
  label: "Featured image",
};

FeaturedImagePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  websiteId: PropTypes.string,
  label: PropTypes.string,
};

export default FeaturedImagePicker;
